module.exports = __webpack_public_path__ + "media/images/image5-8aacc5db2a4c5e20c0bf2d2ef4a3f131.png";